import { createContext } from 'react';
import { Notification } from '../types/workflow';

export interface NotificationContextValue {
  unreadCount: number;
  recentNotifications: Notification[];
  isLoading: boolean;
  lastMarkAllReadAt: number | null;

  refreshCount: () => Promise<void>;
  refreshNotifications: () => Promise<void>;
  markAsRead: (id: number) => Promise<void>;
  markAllAsRead: () => Promise<void>;
  deleteNotification: (id: number) => Promise<void>;
}

export const NotificationContext = createContext<NotificationContextValue | null>(null);
